var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24Paperplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6924 13.3691C20.6924 13.3691 20.6867 13.3748 20.6839 13.3776L6.47059 20.9769C6.2434 21.104 5.98277 21.1585 5.72367 21.1332C5.46458 21.1079 5.21942 21.004 5.02108 20.8354C4.99267 20.8115 4.9654 20.7865 4.93926 20.7604C4.76678 20.589 4.64694 20.3718 4.59388 20.1345C4.54082 19.8972 4.55676 19.6496 4.63981 19.4211L6.89448 13.1083C6.91683 13.0458 6.95793 12.9919 7.01214 12.9537C7.06636 12.9156 7.13105 12.8951 7.19734 12.8952L13.7051 12.8946C13.8727 12.8903 14.032 12.8207 14.149 12.7007C14.266 12.5806 14.3315 12.4196 14.3315 12.252C14.3315 12.0843 14.266 11.9233 14.149 11.8032C14.032 11.6832 13.8727 11.6136 13.7051 11.6093L7.19279 11.6042C7.1265 11.6043 7.06182 11.5838 7.0076 11.5457C6.95338 11.5075 6.91228 11.4535 6.88994 11.3911L4.6472 5.11067C4.55651 4.86662 4.54028 4.60114 4.60057 4.34786C4.66085 4.09458 4.79494 3.86489 4.98586 3.68786C5.18419 3.50804 5.43404 3.3951 5.70006 3.36502C5.96609 3.33494 6.23484 3.38924 6.46832 3.52024L20.6816 11.1195L20.6901 11.128C20.889 11.2397 21.0546 11.4023 21.17 11.5991C21.2853 11.7958 21.3463 12.0198 21.3465 12.2479C21.3467 12.476 21.2863 12.7001 21.1713 12.8971C21.0564 13.0941 20.8911 13.257 20.6924 13.3691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Paperplane);
export default __webpack_public_path__ + "static/media/24_paperplane.da4f7dbc2d4f3494ba3b3623f11ca49e.svg";
export { ForwardRef as ReactComponent };